export enum TransactionQueryKeys {
	DEPOSIT_TRANSACTION = 'deposit-transaction',
	WITHDRAW_TRANSACTION = 'withdraw-transaction',
	FORCE_COMPLETE_DEPOSIT = 'force-complete-deposit',
	MANUAL_DEPOSIT_TRANSACTION = 'manual-deposit-transaction',
	DEPOSIT_TRANSACTION_BY_ID = 'deposit-transaction-by-id',
	WITHDRAW_TRANSACTION_BY_ID = 'withdraw-transaction-by-id',
	MANUAL_APPROVAL_WITHDRAW_THRESHOLD = 'manual-approval-withdraw-threshold',
	TRUE_WALLET_LOGS = 'true-wallet-logs',
	SMS_AUTO_LOGS = 'sms-auto-logs',
	SEARCH_USERS_FOR_REMATCH = 'sms-auto-logs-search-users',
	TRUE_MONEY_DEPOSITS = 'true-money-deposits',
	TRANSACTION_STATISTICS = 'transaction-statistics',
}
